export enum FormMode {
  View,
  Edit,
  New
}